import React from 'react';
import PropTypes from 'prop-types';
import MuiSnackbar from '@material-ui/core/Snackbar';
import { withStyles } from '@material-ui/core/styles';
import { CHILDREN_PROPTYPES } from 'bento-ordering/base/constants/propTypes';

const styles = theme => ({
  root: {
    [theme.breakpoints.down('md')]: {
      bottom: theme.spacing(11.25),
      left: theme.spacing(2.5),
      right: theme.spacing(2.5)
    },
    '& .$MuiSnackbarContent-root': {
      backgroundColor: theme.palette.text.secondary
    }
  }
});

const Snackbar = ({ open, message, onClose, classes }) => {
  return (
    <MuiSnackbar
      open={open}
      onClose={onClose}
      autoHideDuration={3000}
      classes={classes}
      message={message}
      anchorOrigin={{
        horizontal: 'left',
        vertical: 'bottom'
      }}
    />
  );
};

Snackbar.defaultProps = {
  open: false,
  onClose: () => {}
};

Snackbar.propTypes = {
  open: PropTypes.bool,
  classes: PropTypes.shape({}).isRequired,
  onClose: PropTypes.func,
  message: CHILDREN_PROPTYPES.isRequired
};

export default withStyles(styles)(Snackbar);
